import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { ILanguage } from "../../utils/types/models";

export default createEntityReducer<ILanguage>(Endpoint.Languages, Endpoint.LanguagesList);
